'use client';
import React, { useState, useEffect, useCallback } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import AboutSection from '@/components/AboutSection';
import PortfolioSection from '@/components/PortfolioSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';

function PricingToast() {
  const [visible, setVisible] = useState(false);
  const [fading, setFading] = useState(false);

  const showToast = useCallback(() => {
    setFading(false);
    setVisible(true);
    const fadeTimer = setTimeout(() => setFading(true), 4500);
    const hideTimer = setTimeout(() => {
      setVisible(false);
      setFading(false);
    }, 5000);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  useEffect(() => {
    const handler = () => showToast();
    window.addEventListener('showPricingToast', handler);
    return () => window.removeEventListener('showPricingToast', handler);
  }, [showToast]);

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-[9999] transition-opacity duration-500 ${fading ? 'opacity-0' : 'opacity-100'}`}
      style={{ direction: 'rtl' }}
    >
      <div className="flex items-center gap-3 px-6 py-4 rounded-2xl shadow-2xl border border-amber-500/30 text-white text-sm font-medium"
        style={{ background: 'linear-gradient(135deg, #1a1200 0%, #2a1800 100%)', backdropFilter: 'blur(12px)' }}>
        <span className="w-2 h-2 rounded-full bg-amber-400 flex-shrink-0 animate-pulse"></span>
        يرجى اختيار الخدمة للاطلاع على تفاصيل الأسعار.
      </div>
    </div>
  );
}

export default function HomePage() {
  return (
    <main className="min-h-screen" style={{ background: '#0a0a0f' }}>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <PortfolioSection />
      <ContactSection />
      <Footer />
      <ScrollToTop />
      <PricingToast />
    </main>
  );
}
